import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import { InternalAccountActions } from '../actions'
import type { EmailChoices } from '../types'

// Unreadable choices stay null: the section is hidden rather than showing
// switches that guess
export function* loadEmails() {
  try {
    const choices: EmailChoices = yield call(NestClient.account.emails)
    yield put(InternalAccountActions.setEmails(choices))
  } catch (e) {
    console.error('Error while loading email settings', e)
  }
}
